import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchDialogComponent } from '@Work/Accounts/proprietary/controls/search-dialog.component';
import { DataService } from '@Core/services/proprietary/data.service';
import { AppService } from '../../../../../core/services/proprietary/app.service';

@Component({
    standalone: false,
    selector: 'entity-search-dialog',
    templateUrl: './entity-search-dialog.component.html',
    providers: [DataService], //force as a local provider
    styles: [
        `
      [data-initials]:before {
        content: attr(data-initials);
        display: inline-block;
        border: 2px solid;
        border-radius: 4px;
        font-size: 12px;
        width: 18px;
        line-height: 14px;
        text-align: center;
      }
    `
    ]
})
export class EntitySearchDialogComponent extends SearchDialogComponent {
    entityModel = {
        affiliate: false,
        showRoleType: false,
        roleTypeDropdownCodes: [],
        roleTypeNullValue: ''
    };

    constructor(private injector: Injector, private activeModal: NgbActiveModal, public app: AppService) {
        super(injector);
    }

    reset() {
        this.dsCollection.criteria.Entity_Name = '';
        this.dsCollection.criteria.Entity_Quick_Search = '';
        if (this.entityModel.showRoleType) {
            this.dsCollection.criteria.Role_Type = this.entityModel.roleTypeNullValue;
        }
        this.model.dirty = true;
    }

    //Override Method: called to construct initialize the search component
    initialize(): boolean {
        this.parentActiveModal = this.activeModal;
        this.objectType = 'Entity';
        this.model.title = 'Select Entity';

        if (this.model.criteria.Role_Type && this.model.criteria.Role_Type > ' ') {
            switch (this.model.criteria.Role_Type) {
                case 'CN':
                    this.model.title = 'Select Consumer';
                    this.model.criteria.Prospect_Ind = 'Y;N';
                    break;
                case 'CN-A':
                    this.model.title = 'Select Consumer Affiliate';
                    this.model.criteria.Prospect_Ind = 'Y;N';
                    this.entityModel.affiliate = true;
                    break;
                case 'BK':
                    this.model.title = 'Select Broker';
                    break;
                case 'BK-A':
                    this.model.title = 'Select Broker Affiliate';
                    this.entityModel.affiliate = true;
                    break;
                case 'EM':
                    this.model.title = 'Select Employee';
                    break;
                case 'EM-A':
                    this.model.title = 'Select Employee Affiliate';
                    this.entityModel.affiliate = true;
                    break;
                case 'FC':
                    this.model.title = 'Select Finance Company';
                    break;
                case 'FC-A':
                    this.model.title = 'Select Finance Company Affiliate';
                    this.entityModel.affiliate = true;
                    break;
                case 'PR':
                    this.model.title = 'Select Provider';
                    break;
                case 'SP':
                    this.model.title = 'Select Supplier';
                    break;
                case 'SP-A':
                    this.model.title = 'Select Supplier Affiliate';
                    this.entityModel.affiliate = true;
                    break;
                case 'TP':
                    this.model.title = 'Select Third Party';
                    break;
                case 'TP-A':
                    this.model.title = 'Select Third Party Affiliate';
                    this.entityModel.affiliate = true;
                    break;
                case 'TA':
                    this.model.title = 'Select Tax Authority';
                    break;
                case 'TA-A':
                    this.model.title = 'Select Tax Authority Affiliate';
                    this.entityModel.affiliate = true;
                    break;
                case 'CL':
                    this.model.title = 'Select Claimant';
                    break;
                case 'AF':
                //Inline Search may have already converted 'AF' to the list of all affiliate types.
                case 'BK-A;CN-A;SP-A;EM-A;CL-A;BO-A;TP-A;TA-A;FC-A;PR-A':
                    this.model.title = 'Select Affiliate';
                    this.model.criteria.Role_Type = 'BK-A;CN-A;SP-A;EM-A;CL-A;BO-A;TP-A;TA-A;FC-A;PR-A';
                    this.entityModel.affiliate = true;
                    break;

                default:
                    let roleTypes: string = this.model.criteria.Role_Type.toString();

                    if (!roleTypes.includes('-A')) {
                        let roleTypesList = roleTypes.split(';');

                        if (roleTypesList.length > 1) {
                            this.entityModel.showRoleType = true;
                            this.entityModel.roleTypeNullValue = roleTypes;
                            roleTypesList.forEach((roleType) => {
                                switch (roleType) {
                                    case 'BO':
                                        this.entityModel.roleTypeDropdownCodes.push({ Code: 'BO', Code_Desc: 'Book' });
                                        break;
                                    case 'BK':
                                        this.entityModel.roleTypeDropdownCodes.push({ Code: 'BK', Code_Desc: 'Broker' });
                                        break;
                                    case 'CL':
                                        this.entityModel.roleTypeDropdownCodes.push({ Code: 'CL', Code_Desc: 'Claimant' });
                                        break;
                                    case 'CN':
                                        this.entityModel.roleTypeDropdownCodes.push({ Code: 'CN', Code_Desc: 'Consumer' });
                                        break;
                                    case 'EM':
                                        this.entityModel.roleTypeDropdownCodes.push({ Code: 'EM', Code_Desc: 'Employee' });
                                        break;
                                    case 'FC':
                                        this.entityModel.roleTypeDropdownCodes.push({ Code: 'FC', Code_Desc: 'Finance Company' });
                                        break;
                                    case 'PR':
                                        this.entityModel.roleTypeDropdownCodes.push({ Code: 'PR', Code_Desc: 'Provider' });
                                        break;
                                    case 'SP':
                                        this.entityModel.roleTypeDropdownCodes.push({ Code: 'SP', Code_Desc: 'Supplier' });
                                        break;
                                    case 'TA':
                                        this.entityModel.roleTypeDropdownCodes.push({ Code: 'TA', Code_Desc: 'Tax Authority' });
                                        break;
                                    case 'TP':
                                        this.entityModel.roleTypeDropdownCodes.push({ Code: 'TP', Code_Desc: 'Third Party' });
                                        break;
                                }
                            });
                        }
                    }

                    break;
            }
        } else {
            this.model.criteria.Role_Type = '';
            this.entityModel.showRoleType = true;
            this.entityModel.roleTypeDropdownCodes = [
                { Code: 'BO', Code_Desc: 'Book' },
                { Code: 'BK', Code_Desc: 'Broker' },
                { Code: 'CL', Code_Desc: 'Claimant' },
                { Code: 'CN', Code_Desc: 'Consumer' },
                { Code: 'EM', Code_Desc: 'Employee' },
                { Code: 'FC', Code_Desc: 'Finance Company' },
                { Code: 'PR', Code_Desc: 'Provider' },
                { Code: 'SP', Code_Desc: 'Supplier' },
                { Code: 'TA', Code_Desc: 'Tax Authority' },
                { Code: 'TP', Code_Desc: 'Third Party' }
            ];
            this.entityModel.roleTypeNullValue = '';
        }

        this.model.criteria.Max = this.model.currentOptions.maxRows;

        if (!this.model.criteria.View) {
            this.model.criteria.View = 'Full';
        }

        return true;
    }

    /** Role icons are either a Font Awesome class or a bare Aurora icon name. */
    isFontAwesomeIcon(icon: string): boolean {
        return !icon || icon.startsWith('fa');
    }

    getObjectIcon(roletype: any): string {
        let icon = 'fa fa-ep-entity-other';

        if (roletype) {
            switch (roletype.toUpperCase()) {
                case 'SP':
                    icon = 'building';
                    break;
                case 'CN':
                    icon = 'user';
                    break;
                case 'BK':
                    icon = 'briefcase';
                    break;
                case 'EM':
                    icon = 'employee';
                    break;
                case 'CL':
                    icon = 'fa fa-ep-entity-claimant';
                    break;
                case 'BO':
                    icon = 'fa fa-ep-entity-book';
                    break;
                case 'TP':
                    icon = 'fa fa-ep-entity-third-party';
                    break;
                case 'PR':
                    icon = 'fa fa-ep-entity-provider';
                    break;
                case 'TA':
                    icon = 'fa fa-ep-entity-tax-authority';
                    break;
                case 'FC':
                    icon = 'fa fa-ep-entity-finance-company';
                    break;
            }
        }
        return icon;
    }
}
